import { TranslatableSegment } from '../route-translation/helpers/translate-segments';

export interface MenuItem {
	type: MenuItemType;
	label: string;
	route: TranslatableSegment[] | null;
	root: boolean;
	iconRight?: string;
	items?: MenuColumn[][];
	visible?: boolean;
}

export interface MenuColumn {
	items: MenuSubItem[];
}

export interface MenuSubItem {
	key?: string;
	label: string;
	route?: TranslatableSegment[] | null;
	routeUrl?: string;
	nativeLink?: string;
	subtext?: string;
	image?: string;
	icon?: string;
	sideSubtext?: boolean;
	items?: MenuSubItem[];
}

export enum MenuItemType {
	Home,
	Destination,
	LastMinute,
	Contact,
	AboutUs,
	FirstMinute,
	Premium,
	SpecialOffer,
}
